<template>
  <div id="app">
    <router-view/>
      <Toast />
  </div>
</template>
<script>
import Toast from '@/components/common/Toast.vue'

export default {
  name: 'App',
  components: {
    Toast
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* height: 100%; */
    background: linear-gradient(135deg, #F5F5F7 0%, #E8F3FF 100%);
}

* {
  margin: 0;
  padding: 0;
}

body, html {
  height: 100%;
}
</style>
